import {applyMiddleware, createStore} from "redux";
import thunk from "redux-thunk";
import {composeWithDevTools} from "redux-devtools-extension";
import {reducers} from "redux/reducers";
import apiMiddleware from "./middleware";
import {SERVER_PATH} from "../assets/constants";


const middleware = [thunk, apiMiddleware(SERVER_PATH)];

const store = createStore(
    reducers,
    composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
